import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { X, Send, CalendarCheck, Clock } from "lucide-react";
import { API } from "@/lib/api";

const inputCls =
  "w-full rounded-xl bg-white/5 border border-white/15 px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-[#D4AF37]/60 transition-colors text-sm";

export default function RequestModal({ type, vehicle, category, onClose }) {
  const [form, setForm] = useState({ name: "", phone: "", comment: "" });
  const [loading, setLoading] = useState(false);
  const isRes = type === "reservation";
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const title = isRes ? "ავტომობილის დაჯავშნა" : "რიგში ჩადგომა";
  const subtitle = isRes
    ? "დაგვიტოვე საკონტაქტო ინფორმაცია — დაგიკავშირდებით დასადასტურებლად."
    : "შეგატყობინებთ, როგორც კი ეს ავტომობილი გათავისუფლდება.";
  const vehicleName = vehicle.public_title || `${vehicle.internal_name || category?.name || ""} · ${vehicle.year}`;

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      toast.error("შეავსე სახელი და ტელეფონის ნომერი");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/${isRes ? "reservations" : "waitlist"}`, { ...form, vehicle: vehicle.id });
      toast.success(isRes ? "დაჯავშნა გაიგზავნა — მალე დაგიკავშირდებით!" : "შენ რიგში ხარ — გათავისუფლებისას შეგატყობინებთ!");
      onClose();
    } catch (err) {
      toast.error(typeof err.response?.data?.detail === "string" ? err.response.data.detail : "გაგზავნა ვერ მოხერხდა");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center bg-black/70 backdrop-blur-sm p-4"
      onClick={onClose}
      data-testid={`${type}-modal`}
    >
      <form
        onClick={(e) => e.stopPropagation()}
        onSubmit={submit}
        className="card-lux w-full max-w-md p-7 space-y-5"
        data-testid={`${type}-form`}
      >
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="w-11 h-11 rounded-xl bg-[#D4AF37]/12 flex items-center justify-center mb-3">
              {isRes ? <CalendarCheck className="w-5 h-5 text-[#D4AF37]" /> : <Clock className="w-5 h-5 text-[#D4AF37]" />}
            </div>
            <h2 className="text-xl font-bold text-white">{title}</h2>
            <p className="text-sm text-gray-400 mt-1">{subtitle}</p>
            <p className="text-sm text-[#E5C378] mt-2 font-medium" data-testid={`${type}-vehicle-name`}>{vehicleName}</p>
          </div>
          <button type="button" onClick={onClose} data-testid={`${type}-close`} className="text-gray-400 hover:text-white p-1">
            <X className="w-5 h-5" />
          </button>
        </div>
        <input type="text" required value={form.name} onChange={set("name")} placeholder="სახელი" data-testid={`${type}-name-input`} className={inputCls} />
        <input type="tel" required value={form.phone} onChange={set("phone")} placeholder="ტელეფონის ნომერი *" data-testid={`${type}-phone-input`} className={inputCls} />
        <textarea rows={3} value={form.comment} onChange={set("comment")} placeholder="კომენტარი" data-testid={`${type}-comment-input`} className={`${inputCls} resize-none`} />
        <button type="submit" disabled={loading} data-testid={`${type}-submit`} className="btn-gold w-full disabled:opacity-60">
          {loading ? "იგზავნება..." : isRes ? "დაჯავშნის გაგზავნა" : "რიგში ჩადგომა"} <Send className="w-4 h-4" />
        </button>
      </form>
    </div>
  );
}
